(function() {
  /* bundles management */

  // Always returns a Promise. If bundle -> show modal first. If confirmed => return items, else return [].
  $s.getItemsToUpdate = function(sourceItem, newQuantity) {
    return new Promise((resolve) => {
      // If this item belongs to a bundle (and is not an individual bundle item)
      if (sourceItem.dataset.bundleId && sourceItem.dataset.bundleItem != 'individual') {
        // Prevent multiple modals if one is already open
        if (document.querySelector('.modal-backdrop')) {
          // If there's already a modal, cancel this action to avoid duplicate prompts
          return resolve([]);
        }

        // Show modal and handle the response
        showBundleRemovalModal().then((confirmed) => {
          if (!confirmed) {
            // User cancelled → resolve with empty array
            return resolve([]);
          }

          // User confirmed -> get items to remove/update
          const items = $s.removeItems(sourceItem, newQuantity);

          // If you want immediate cart actions here, do them now (example placeholder):
          // $s.updateCartItemsQuantity({ updates: ... }) or similar.
          // For now we just resolve the items array so caller can act.
          resolve(items);
        }).catch((err) => {
          console.error('Modal error', err);
          resolve([]); // fail-safe
        });
      } else {
        var items = [sourceItem];
        items = Array.from(items);
        // Not a bundle → resolve with the single item
        SideCart.updateItemsQuantity(items, newQuantity);
      }
    });
  };

  // ---------------------------------------------------------------
  // Handles selecting the correct bundle or single items to remove
  // ---------------------------------------------------------------
  $s.removeItems = function(sourceItem, newQuantity){
    var items = [sourceItem];
    if (sourceItem.dataset.bundleId && sourceItem.dataset.bundleItem!='individual') {
      if (newQuantity==0) {
        items = sourceItem.parentNode.querySelectorAll('[data-bundle-id="'+ sourceItem.dataset.bundleId +'"]');     
      } else {
        items = sourceItem.parentNode.querySelectorAll('[data-bundle-id="'+ sourceItem.dataset.bundleId +'"][data-bundle-item="main"], [data-bundle-id="'+ sourceItem.dataset.bundleId +'"][data-bundle-item="related_multiple"]');
      }
      items = Array.from(items);
    }

    SideCart.updateItemsQuantity(items, newQuantity);
  }

  /*
  items: is an array of cart items from the cart page or side cart
  mustFixItems: is a boolean, default is true
  callback: function to be called after validation and fixing items if required. The callback first argument receives the result of the validation (true, or false if there was a problem), default callback triggers a location.reload() when the cart had to be fixed;
  */
  $s.validateBundlesInJson = function(items, mustFixItems, callback) {
    var data = {items: items};
    validateBundles(data, mustFixItems, callback);
  }

  async function validateBundles(data, mustFixItems, callback) {
    var bundles = {};
    if (typeof(mustFixItems)=='undefined') {
      mustFixItems = true;
    }
    var dataUpdate = {updates: {}};
    data.items.forEach(function(item) {
      var id = item.properties._bundle_id;
      if (id && item.properties._bundle_item != 'individual') {
        if (!bundles[id]) {
          bundles[id] = []
        }
        bundles[id].push(item);
      }
    });
    for (var id in bundles) {
      var items = bundles[id];
      //reduce quantity of items limited to 1
      items.forEach(function(item) {
        if (item.properties._bundle_item=='related_single' && item.quantity > 1) {
          dataUpdate.updates[item.key] = 1
        }
      })
      //delete the items without main or missing childs
      const mainItem = items.find((x)=>x.properties._bundle_item=='main');
      if (!mainItem || (mainItem.properties._bundle_positions && mainItem.properties._bundle_positions/1!=items.length )) {
        items.forEach((item)=>dataUpdate.updates[item.key] = 0);
      }
      
    }

    if (Object.keys(dataUpdate.updates).length) {
      if (mustFixItems) {
        $s.showLoadingOverlay();
        $s.updateCartItemsQuantity(dataUpdate).then(function() {
          if (callback) {
            $s.hideLoadingOverlay();
            callback(false);
          } else {
            location.reload();
          }
        }).catch($s.addToCartFail);
      } else {
        if (callback) {
          callback(false);
        }
      }
      
    } else {
      if (callback) {
        callback(true);
      }
    }

  }

})(); // end IIFE


// ---------------------------------------------------------------
// Confirmation modal for bundle removal (unchanged)
// ---------------------------------------------------------------
function showBundleRemovalModal() {
  return new Promise((resolve) => {
    const modal = document.createElement('div');
    modal.innerHTML = `
      <div class="modal-backdrop" style="
        position: fixed; inset: 0;
        background: rgba(0,0,0,0.5);
        display: flex; align-items: center; justify-content: center;
        z-index: 9999;">
        <div class="modal-box" style="
          background: white; padding: 20px;
          border-radius: 8px; max-width: 400px;
          text-align: center;">
          <h3 style="margin-bottom: 15px; font-size: 18px;">
            Are you sure you want to remove your bundle?
          </h3>
          <p style="margin-bottom: 20px;">
            All bundle items will be removed from cart.
          </p>
          <div style="display: flex; justify-content: space-around;">
            <button id="bundleConfirm" style="
              background: #a60800; color: white;
              border: none; padding: 8px 16px;
              border-radius: 5em; cursor: pointer;">Continue</button>
            <button id="bundleCancel" style="
              background: #6c757d; color: white;
              border: none; padding: 8px 16px;
              border-radius: 5em; cursor: pointer;">Cancel</button>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(modal);

    modal.querySelector('#bundleConfirm').addEventListener('click', () => {
      modal.remove();
      resolve(true);
    });

    modal.querySelector('#bundleCancel').addEventListener('click', () => {
      modal.remove();
      resolve(false);
      SideCart.showSideCart(true);
    });
  });
}
